import { TransformInt } from '../../../decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../authz';
import { UserWatchOptionEnum } from '../enums/user-watch-option.enum';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * User Watch Preference DTO
 */
export class UserWatchPreferenceDto {
  @TransformInt()
  id?: number;
  @TransformInt()
  userId!: number;
  subject!: AppSubjectEnum;
  @TransformInt()
  subjectId!: number;
  option!: UserWatchOptionEnum;
}
